var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.326 11.006c.204-.174.305-.261.343-.365a.417.417 0 000-.282c-.038-.104-.14-.19-.343-.365l-7.059-6.05c-.35-.3-.525-.45-.673-.455a.417.417 0 00-.334.154c-.093.115-.093.345-.093.806v3.58a8.055 8.055 0 00-6.667 7.93v.51a9.5 9.5 0 016.667-3.41v3.492c0 .46 0 .691.093.806.082.1.205.157.334.154.148-.004.323-.154.673-.454l7.06-6.05z",
    stroke: "#7A89F4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgShare;